export { default } from './WhoWeAreView';



// WEBPACK FOOTER //
// ./src/components/views/WhoWeAreView/index.js